import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import ExternalSevice from "services/ExternalSevice";

let initialState = { data: null };

export const checkCompany = createAsyncThunk(
  "company/checkCompany",
  async (juristicID) => {
    const response = await ExternalSevice.checkCompany(juristicID);
    return response?.results;
  }
);

export const companySlice = createSlice({
  name: "company",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(checkCompany, builder, ["data"]);
  },
});

export const selectCheckCompany = (state) => state.company;

export default companySlice.reducer;
